import {Component, OnInit} from '@angular/core';
import {IdService} from "../../services/id/id.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PermissionsService} from "../../services/permissions/permissions.service";
import Constants from "../../shared/constants";

@Component({
    selector: 'xlog-join-team',
    templateUrl: './join-team.component.pug',
    styleUrls: ['./join-team.component.scss'],
    standalone: false
})
export class JoinTeamComponent implements OnInit {
    joinOrgDisabledButtons: { [orgId: string]: boolean } = {};
    invitedOrgDisabledButtons: { [orgId: string]: boolean } = {};
    data = {};
    joinOrgs = {};
    invitedOrgs = {};
    token = '';
    email = '';
    loaded = false;
    showBanner = false;
    DEFAULT_LOGO = "https://xref-assets.xref.com/images/organisation/Group%204324-large.jpeg";

    constructor(
        public id: IdService,
        private router: Router,
        private route: ActivatedRoute,
        public featureFlagService: PermissionsService
    ) {
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            this.token = params['t'];
            this.email = params['email'];
            if (!this.token || !this.email) {
                this.router.navigate(['signup/expired']);
            }
        });
        const state = history.state;
        this.joinOrgs = state?.data?.join_orgs;
        this.invitedOrgs = state?.data?.invited_orgs;
        this.loaded = true;
    }

    createOrganisation() {
        localStorage.setItem('previousUrl', '/signup/join-team');
        this.loaded = false;
        const data = {
            "action": Constants.SIGNUP_CLICKED_CREATE_ORG,
            "meta": {},
        };
        this.id.logButtonClick(this.token, data).subscribe();
        window.location.href = `/user-details/${encodeURIComponent(this.email)}?t=${encodeURIComponent(this.token)}`;
    }


    acceptInvitation(org) {
        const data = {
            "action": Constants.SIGNUP_CLICKED_ACCEPT_INVITATION,
            "meta": {'global_org_uuid': org.global_org_uuid},
        };
        this.id.logButtonClick(this.token, data).subscribe();
        this.invitedOrgDisabledButtons[org.org_id] = true;
        window.open(org.invitation_link, "_blank");
    }

    requestInvitation(org) {
        this.loaded = false;
        const clickData = {
            "action": Constants.SIGNUP_CLICKED_REQUEST_INVITATION,
            "meta": {'global_org_uuid': org.global_org_uuid},
        };
        this.id.logButtonClick(this.token, clickData).subscribe();

        const data = {
            "organisation_uuid": org.global_org_uuid,
            "organisation_name": org.org_name,
            "email": this.email
        };

        this.id.requestInvitation(this.token, data).subscribe(
            () => {
                this.joinOrgDisabledButtons[org.org_id] = true;
                this.loaded = true;

            }, () => {
                this.showAlertBanner();
                this.loaded = true;
            }
        );
    }

    redirectToContactSupportPage() {
        const data = {
            "action": Constants.SIGNUP_CLICKED_CONTACT_SUPPORT,
            "meta": {},
        };
        this.id.logButtonClick(this.token, data).subscribe();
        window.open(Constants.SIGNUP_CONTACT_XREF_URL, "_blank");
    }

    showAlertBanner() {
        this.showBanner = true;
        setTimeout(() => {
            this.showBanner = false;
        }, 5000);  // Hide after 5 seconds
    }
}
